import isPlainObject from 'lodash/isPlainObject'
import {saferStringify} from '@freckle/parser'
import {
  ActionableHttpError,
  NonActionableHttpError
} from '../../helpers/ajax/helpers/errors/http-error'

export class WithResourcesError extends Error {
  status: number | undefined | null
  modelKey: string | number | symbol
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(error: any, modelKey: string | number | symbol) {
    super(`Non-error throw while fetching ${String(modelKey)} ${saferStringify(error)}`)
    this.name = 'WithResourcesError'

    //Stash status so that bugsnag reporting can ignore it if need be
    this.status = getStatus(error)
    this.modelKey = modelKey
  }
  bugsnagGroupingHash(): string {
    return `${window.location.pathname} ${String(this.modelKey)}`
  }
}

const getStatus = (error: unknown): number | undefined | null => {
  if (error instanceof ActionableHttpError || error instanceof NonActionableHttpError) {
    return error.response.response.status
  }

  if (isPlainObjectTyped(error) && error.status) {
    return parseInt(error.status, 10)
  }

  return null
}

const isPlainObjectTyped = (error: unknown): error is {status?: string} => {
  return isPlainObject(error)
}
